import impersonation from "./components/impersonation"
import orders from "./components/orders"

export default {
    impersonation,
    orders
}